import { KalturaRecordingType } from '@kaltura-ott/ott-client-types/api/types';
import { KuxBookmark, KuxRecord, KuxSeriesRecord } from '@kaltura-ott/tvpil';
import { computed, observable } from 'mobx';

export class Record {
  @observable.ref data: KuxRecord;
  @observable.ref bookmark?: KuxBookmark;

  constructor(data: KuxRecord) {
    this.data = data;
  }

  @computed get isSeriesRecord(): boolean {
    return this.data.type === KalturaRecordingType.series;
  }

  @computed get isSingleRecord(): boolean {
    return this.data.type === KalturaRecordingType.single;
  }
}

export class SeriesRecord {
  @observable data: KuxSeriesRecord;

  constructor(data: KuxSeriesRecord) {
    this.data = data;
  }
}
